
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users, UserPlus, Mail, Settings } from 'lucide-react';

interface CRMNavigationPanelProps {
  activePanel: 'users' | 'upload' | 'bulk' | 'settings';
  onPanelChange: (panel: 'users' | 'upload' | 'bulk' | 'settings') => void;
}

const CRMNavigationPanel: React.FC<CRMNavigationPanelProps> = ({
  activePanel,
  onPanelChange,
}) => {
  return (
    <div className="mb-6">
      <div className="inline-flex items-center gap-3 border rounded-lg p-1">
        <Button 
          variant={activePanel === 'users' ? 'default' : 'ghost'} 
          size="sm"
          onClick={() => onPanelChange('users')}
          className="flex items-center gap-1"
        >
          <Users className="h-4 w-4 mr-1" />
          Users
        </Button>
        <Button 
          variant={activePanel === 'upload' ? 'default' : 'ghost'} 
          size="sm"
          onClick={() => onPanelChange('upload')}
          className="flex items-center gap-1"
        >
          <UserPlus className="h-4 w-4 mr-1" />
          CSV Upload
        </Button>
        <Button 
          variant={activePanel === 'bulk' ? 'default' : 'ghost'} 
          size="sm"
          onClick={() => onPanelChange('bulk')}
          className="flex items-center gap-1"
        >
          <Mail className="h-4 w-4 mr-1" />
          Bulk Invite
        </Button>
        <Button 
          variant={activePanel === 'settings' ? 'default' : 'ghost'} 
          size="sm"
          onClick={() => onPanelChange('settings')}
          className="flex items-center gap-1"
        >
          <Settings className="h-4 w-4 mr-1" />
          Settings
        </Button>
      </div>
    </div>
  );
};

export default CRMNavigationPanel;

